export default __webpack_public_path__ + "static/custom-software-sviluppo-su-misura-astrorei-18569323961e62f1a0752e727ed777a2.jpg";